var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hero",style:({
		backgroundImage: ("url('" + (require('@/assets/' + _vm.heroImage + '')) + "')"),
	})},[_c('div',{staticClass:"image-overlay"}),_c('h3',{staticClass:"hero-text"},[_vm._v(_vm._s(_vm.heroText))])])}
var staticRenderFns = []

export { render, staticRenderFns }